function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitize a string for XSS attacks.
 *
 * Uses [Isomorphic DOMPurify](https://github.com/kkomelin/isomorphic-dompurify)
 * for compatibility with Next.js.
 *
 * Underlying library is [DOMPurify](https://github.com/cure53/DOMPurify).
 *
 * @param value string | Node
 * @param config SantizeConfig | undefined
 * @returns string
 */
var sanitize = function sanitize(value) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ADD_IFRAME_SANDBOX = config.ADD_IFRAME_SANDBOX,
    ALLOW_IFRAME_CHILDREN = config.ALLOW_IFRAME_CHILDREN,
    ALLOWED_IFRAME_DOMAINS = config.ALLOWED_IFRAME_DOMAINS;
  if (ADD_IFRAME_SANDBOX || ALLOW_IFRAME_CHILDREN || ALLOWED_IFRAME_DOMAINS) {
    /**
    * https://github.com/cure53/DOMPurify/issues/766#issuecomment-1429955205
    */
    if (ALLOW_IFRAME_CHILDREN) {
      DOMPurify.addHook('uponSanitizeElement', function (cn) {
        if (cn.tagName === 'IFRAME' && cn.innerHTML) {
          cn.dataset.temp = cn.innerHTML;
          cn.innerHTML = '';
        }
      });
      DOMPurify.addHook('afterSanitizeElements', function (cn) {
        if (cn.tagName === 'IFRAME' && cn.dataset.temp) {
          cn.innerHTML = DOMPurify.sanitize(cn.dataset.temp);
          delete cn.dataset.temp;
        }
      });
    } else {
      DOMPurify.removeHook('uponSanitizeElement');
      DOMPurify.removeHook('afterSanitizeElements');
    }
    if (ALLOWED_IFRAME_DOMAINS) {
      DOMPurify.addHook('beforeSanitizeAttributes', function (cn) {
        if (cn.tagName === 'IFRAME') {
          var src = cn.getAttribute('src');
          if (src && !ALLOWED_IFRAME_DOMAINS.some(function (domain) {
            return src.includes(domain);
          })) {
            cn.remove();
          }
        }
      });
    } else {
      DOMPurify.removeHook('beforeSanitizeAttributes');
    }
    if (ADD_IFRAME_SANDBOX) {
      DOMPurify.addHook('afterSanitizeAttributes', function (cn) {
        if (cn.tagName === 'IFRAME') {
          cn.setAttribute('sandbox', ADD_IFRAME_SANDBOX);
        }
      });
    } else {
      DOMPurify.removeHook('afterSanitizeAttributes');
    }
  } else {
    DOMPurify.removeAllHooks();
  }
  return DOMPurify.sanitize(value, _objectSpread({}, config && config));
};
export { sanitize };